export const primaryColor = "#8deb0f";
export const secondaryColor = "#0f0f0f";
export const textWithWhiteBg = "#0f0f0f";
export const textWithPrimaryColorBg = "#0f0f0f";
export const linearGradient =
  "linear-gradient(107deg, rgba(15, 15, 15, 0.60) 0%, rgba(15, 15, 15, 0.36) 33.48%, rgba(141, 235, 15, 0.36) 80.05%, rgba(141, 235, 15, 0.60) 100.44%)";
